import openUrl from "../utils/openUrl";

// ------------------------------------------------------------
// All of the Link IDs that are used throughout the tutorial
// ------------------------------------------------------------

// Note: it is important the string values do not contain underscores!
export const ExternalLinkIdentifiers = {
  PREPARE_SYNC_PROJECT: `PrepareSyncProject`,
  NARRATIVE_VS_CHRONOLOGY: `NarrativeVsChronology`,
  HOW_TO_OPEN_VIEW: `HowToOpenView`
};

// ------------------------------------------------------------
// Where do the external links point to?
// ------------------------------------------------------------

export const ExternalLinkUrls = {
  [ExternalLinkIdentifiers.PREPARE_SYNC_PROJECT]:
    "https://help.timeline.app/article/227-preparing-an-existing-writing-project-for-syncing",
  [ExternalLinkIdentifiers.NARRATIVE_VS_CHRONOLOGY]:
    "https://help.timeline.app/article/149-chronological-vs-narrative-order",
  [ExternalLinkIdentifiers.HOW_TO_OPEN_VIEW]: "https://help.timeline.app/article/234-switching-view-types"
};

// ------------------------------------------------------------
// Respond to a user clicking on a link
// ------------------------------------------------------------

export const onTutorialLinkClick = id => {
  if (ExternalLinkUrls[id]) {
    openUrl(ExternalLinkUrls[id]);
  }
};
